var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequirement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.96094C17.1269 1.96094 17.5 2.33404 17.5 2.79427V5.9251L15.8333 7.59177V3.6276H4.16667V16.9609H15.8333V14.6626L17.5 12.9959V17.7943C17.5 18.2545 17.1269 18.6276 16.6667 18.6276H3.33333C2.8731 18.6276 2.5 18.2545 2.5 17.7943V2.79427C2.5 2.33404 2.8731 1.96094 3.33333 1.96094H16.6667ZM18.1485 7.63395L19.327 8.81244L12.8452 15.2943L11.6649 15.2925L11.6667 14.1158L18.1485 7.63395ZM11.6667 10.2943V11.9609H8.33333V10.2943H11.6667ZM14.1667 6.96094V8.6276H8.33333V6.96094H14.1667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7.79427C6.66667 8.25451 6.29357 8.6276 5.83333 8.6276C5.3731 8.6276 5 8.25451 5 7.79427C5 7.33403 5.3731 6.96094 5.83333 6.96094C6.29357 6.96094 6.66667 7.33403 6.66667 7.79427Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 11.1276C6.66667 11.5878 6.29357 11.9609 5.83333 11.9609C5.3731 11.9609 5 11.5878 5 11.1276C5 10.6674 5.3731 10.2943 5.83333 10.2943C6.29357 10.2943 6.66667 10.6674 6.66667 11.1276Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirement);
export default __webpack_public_path__ + "static/media/Requirement.bef2f94dca9cc5a4296d2d40af5361f4.svg";
export { ForwardRef as ReactComponent };